import { booleanAttribute, Component, computed, input } from '@angular/core';

export type AvatarSize = 'small' | 'normal' | 'large' | 'xlarge';

@Component({
  selector: 'app-avatar',
  imports: [],
  templateUrl: './avatar.html',
})
export class Avatar {
  readonly image = input<string | null | undefined>();
  readonly name = input<string | null | undefined>();
  readonly initials = input<string | null | undefined>();
  readonly size = input<AvatarSize>('normal');
  readonly showLabel = input(false, { transform: booleanAttribute });

  readonly avatarClasses = computed(() => {
    const sizeValue = this.size();
    const sizeMap = {
      small: 'w-6 h-6 text-xs',
      normal: 'size-9 text-sm',
      large: 'w-12 h-12 text-xl',
      xlarge: 'w-16 h-16 text-3xl',
    };
    return `rounded-full object-cover shrink-0 flex items-center justify-center bg-primary text-on-accent font-medium ${sizeMap[sizeValue]}`;
  });

  readonly labelClasses = computed(() => {
    const sizeValue = this.size();
    const sizeMap = {
      small: 'text-xs',
      normal: 'text-sm',
      large: 'text-2xl font-medium',
      xlarge: 'text-3xl font-medium',
    };
    return `text-text ${sizeMap[sizeValue]}`;
  });
}
